import * as yup from 'yup';

function clientName(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'CLIENT_NAME_IS_REQUIRED',
        defaultMessage: 'Client Name is required',
      }),
    )
    .max(
      64,
      formatMessage({
        id: 'CREATEFORM_CLIENTNAME_FIELD_MAX_CHARS_64',
        defaultMessage: 'Client Name should be less than 64 chars',
      }),
    );
}

function clientNumber(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'CLIENT_NUMBER_IS_REQUIRED',
        defaultMessage: 'Client Number is required',
      }),
    )
    .max(
      32,
      formatMessage({
        id: 'CREATEFORM_CLIENTNUMBER_FIELD_MAX_CHARS_32',
        defaultMessage: 'Client Number should be less than 32 chars',
      }),
    );
}

function status(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'STATUS_IS_REQUIRED',
      defaultMessage: 'Status is required',
    }),
  );
}

function underwriterApprovalRequired(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'UNDERWRITER_APPROVAL_REQUIRED_IS_REQUIRED',
      defaultMessage: 'Underwriter Approval Required is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      clientName: clientName(formatMessage),
      clientNumber: clientNumber(formatMessage),
      status: status(formatMessage),
      underwriterApprovalRequired: underwriterApprovalRequired(formatMessage),
    })
    .required();

export default validationSchema;
